import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';

const OpenReturnExchangeAttachment = (props) => {
  const { text, title, orderReturnExchangeId, type, reason, getRequestRejectAttachmentData } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(reason) || isNil(orderReturnExchangeId)) {
    return '-';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine={true}
      text={text}
      onClick={() =>
        getRequestRejectAttachmentData({
          title,
          orderReturnExchangeId,
          type,
          reason,
        })
      }
    />
  );
};

export default OpenReturnExchangeAttachment;
